<template>
  <AdminLayout>
    <div>
      <v-btn-toggle
        v-if="!showPreview"
        v-model="activeTab"
        variant="flat"
        divided
        mandatory
        rounded="xl"
        :base-color="
          $vuetify.theme.global.name === 'dark' ? '#272727' : '#f5f5f5'
        "
        border
        selected-class="active-button"
      >
        <v-btn value="bookables" class="text-capitalize">Buchungsobjekte</v-btn>
        <v-btn value="events" class="text-capitalize">Veranstaltungen</v-btn>
      </v-btn-toggle>
      <div v-if="!showPreview" class="mt-3">
        <h2 class="mb-3" v-if="activeTab === 'bookables'">
          Buchungsobjekte importieren
        </h2>
        <h2 class="mb-3" v-else>Veranstaltungen importieren</h2>
      </div>

      <div v-if="!showPreview">
        <ExcelUpload
          :type="activeTab"
          @file-uploaded="onExcelUploaded"
          @file-removed="importedRows = []"
          class="mb-4"
        />
        <ZipUpload
          :type="activeTab"
          @file-uploaded="onZipUploaded"
          @file-removed="zipImages = []"
        />
        <div class="text-right mt-6">
          <v-btn
            color="primary"
            size="large"
            :disabled="!importedRows?.length"
            @click="showPreview = true"
          >
            Weiter
            <v-icon end>mdi-arrow-right</v-icon>
          </v-btn>
        </div>
      </div>
      <ImportPreview
        v-else
        :type="activeTab"
        :headers="importedHeaders"
        :rows="importedRows"
        :zip-images="zipImages"
        @back="resetImportView"
      />
    </div>
  </AdminLayout>
</template>

<script>
import AdminLayout from "@/layouts/Admin.vue";
import ExcelUpload from "@/components/Import/ExcelUpload.vue";
import ZipUpload from "@/components/Import/ZipUpload.vue";
import ImportPreview from "@/components/Import/ImportPreview.vue";

export default {
  components: { AdminLayout, ExcelUpload, ZipUpload, ImportPreview },
  data() {
    return {
      activeTab: "bookables",
      zipImages: [],
      importedRows: [],
      importedHeaders: [],
      showPreview: false,
    };
  },
  methods: {
    async onExcelUploaded({ headers, rows }) {
      this.importedRows = rows;
      this.headers = headers;
    },
    async onZipUploaded(images) {
      this.zipImages = images;
    },
    resetImportView() {
      this.showPreview = false;
      this.zipImages = [];
      this.importedRows = [];
      this.importedHeaders = [];
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .active-button {
  color: black !important;
  background-color: rgb(var(--v-theme-secondary)) !important;
}
</style>
